export type LifetimeSeriesKey =
  | "added"
  | "sold"
  | "returned"
  | "ordered"
  | "lost"
  | "damaged";

export type LifetimeChartSeriesId = LifetimeSeriesKey | "stockBalance";

export interface LifetimeSeriesMeta {
  key: LifetimeSeriesKey;
  label: string;
  color: string;
}

export interface LifetimeFlowSeriesMeta extends LifetimeSeriesMeta {
  direction: "in" | "out";
}

// Stock movements drawn as diverging stacked bars: "in" grows the stock
// balance and stacks up from zero, "out" shrinks it and stacks down.
export const LIFETIME_FLOW_SERIES: LifetimeFlowSeriesMeta[] = [
  { key: "added", label: "Added", color: "#03bf9d", direction: "in" },
  { key: "returned", label: "Returned", color: "#0079ae", direction: "in" },
  { key: "sold", label: "Sold", color: "#fb3973", direction: "out" },
  { key: "lost", label: "Lost", color: "#ff9900", direction: "out" },
  { key: "damaged", label: "Damaged", color: "#ff0033", direction: "out" }
];

// Demand rather than a stock movement, so it is drawn as a dashed line
// instead of a bar.
export const ORDERED_SERIES: LifetimeSeriesMeta = {
  key: "ordered",
  label: "Ordered",
  color: "#9900ff"
};

// Column order of the by-barcode breakdown table.
export const LIFETIME_SERIES: LifetimeSeriesMeta[] = [
  ...LIFETIME_FLOW_SERIES,
  ORDERED_SERIES
];

export const STOCK_BALANCE_COLOR = "#1b1d21";
